<ion-footer class="hidden-lg hidden-md">
    <ion-tab-bar slot="bottom">
        <ion-tab-button (click)="switchPage('search')">
            <ion-text class="footer-links-label">Search</ion-text>
            <ion-icon mode="md" name="search" size="large"></ion-icon>
        </ion-tab-button>
        <ion-tab-button (click)="switchPage('dashboard')">
            <ion-text class="footer-links-label">Dashboard</ion-text>
            <ion-icon mode="md" src="assets/svg/AMO_orange.svg" size="large"></ion-icon>
        </ion-tab-button>

        <ion-tab-button *ngIf="(itineraryList$ | async).length > 0 && enableItineraries" (click)="switchPage('itinerary-create')">
            <ion-fab class="nav-fab-button" *ngIf="(itineraryList$ | async).length > 0">
                <ion-fab-button>
                    {{ (itineraryList$ | async).length }}
                </ion-fab-button>
            </ion-fab>
            <ion-text class="footer-links-label">Itinerary</ion-text>
            <ion-icon mode="ios" name="list" size="large"></ion-icon>
        </ion-tab-button>
        <ion-tab-button (click)="switchPage('profile')">
            <ion-text class="footer-links-label">Profile</ion-text>
            <ion-icon mode="md" name="person-circle-outline" size="large"></ion-icon>
        </ion-tab-button>
    </ion-tab-bar>
</ion-footer>
